export default __webpack_public_path__ + "static/media/avatar_pyper3.b6531795.mp3";